import { Center, Flex, Text } from "@chakra-ui/react";
import { ReactElement } from "react";
import Layout from "../../scenes/layouts";

const NotAuthorizedScene = (): ReactElement => {
    return (
        <Layout>
            <Center width={"100vw"} height={"100vh"}>
                <Flex alignItems={'center'}>
                    <Text size={'3xl'} fontWeight={'bold'} color={'red.800'}>Your are not Authorized.</Text>
                </Flex>
            </Center>
        </Layout>
    );
};

export default NotAuthorizedScene;